import { $, $$ } from 'utils/dom';
import Filter from 'modules/Filter/filter';

const linklists = $$('.o-linklist');

if (linklists.length) {
  linklists.forEach(linklist => {
    if ($('.o-filter', linklist)) {
      new Filter({
        container: linklist,
        filter: $('.o-filter', linklist),
        items: $$('.o-linklist__item', linklist),
        hiddenClass: 'o-linklist__item--hidden',
        activeClass: 'o-linklist__item--active',
      }).init();
    }
  });
}
